<template>
  <div>
    <el-button-group>
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-edit"
        v-if="allow('A')"
        v-show="!disabled"
        @click="fromLoad('add')"
        >新增</el-button
      >
      <el-button
        v-if="tableData.length > 0"
        type="primary"
        size="mini"
        icon="el-icon-edit"
        @click="exportFile"
        >导出</el-button
      >
    </el-button-group>
    <el-table :data="tableData" v-loading="loading" stripe size="mini">
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="detailItemName"
        label="明细登记项名称"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="fromLoad('detail', scope.row)">{{
            scope.row.detailItemName
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="detailItemValue"
        label="明细登记项值"
        min-width="150"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="detailItemNotice"
        label="注意事项"
        min-width="150"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="detailItemRemark"
        label="备注信息"
        min-width="150"
      ></el-table-column>
      <el-table-column
        v-if="!disabled"
        label="操作"
        width="100"
        fixed="right"
        align="left"
      >
        <template slot-scope="scope">
          <el-button
            @click="fromLoad('edit', scope.row)"
            type="text"
            size="mini"
            v-if="allow('M')"
            >修改</el-button
          >
          <el-button
            @click="delRow(scope.row.prjInfoMaterialCode)"
            type="text"
            size="mini"
            v-if="allow('D')"
            >删除</el-button
          >
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </div>
    </el-table>

    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="950px"
    >
      <page-detail
        ref="form"
        :params="params"
        @success="saveSuccess"
      ></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { delSingleMaterialItem } from '@api/projectManager/infoMaterial'

export default {
  props: {
    tableData: {
      default: () => []
    },
    params: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    },
    disabled: {
      default: true,
      type: Boolean
    }
  },
  components: {
    PageDetail: () => import('./components/detail')
  },
  data() {
    return {
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      }
    }
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = '') {
      const opt = {
        add: '新增',
        edit: '编辑',
        detail: '详情'
      }
      // 设置标题
      this.formOption.title = opt[ref]
      // 控制保存按钮显隐
      if (ref === 'add') {
        // 新增时传 prjCode 项目编码
        val = this.params.prjCode
      }
      if (ref === 'detail') {
        this.formOption.dialogSaveBtnVisible = false
      } else {
        this.formOption.dialogSaveBtnVisible = true
      }
      // 显示表单
      this.formOption.dialogFormVisible = true
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val)
      }, 0)
    },
    delRow(val) {
      this.$confirm('是否删除？').then(() => {
        this.$api
          .delSingleMaterialItemApi({ prjInfoMaterialCode: val })
          .then((res) => {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success'
            })
            this.$emit('submit')
          })
      })
    },
    exportFile() {
      let url = '/project/infoMaterial/getProjectInfoMaterial/export'
      let fileName = '面料打样明细'
      this.exportData(url, this.params, fileName)
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.cancel()
      this.$emit('submit')
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    }
  }
}
</script>
